import * as actionTypes from "./actionTypes";

const initialState = {
successState : null,
data : "",
updated : false
};



const submitAnIdeaReducer = (state = initialState, action) => {

  switch (action.type) {
    case actionTypes.submitAnIdeaSuccess:
    
      return {
        ...state,
        successState : true, message : action.payload, updated : true
      };

      case actionTypes.submitAnIdeaFailed:
        
        return {
          ...state, 
          successState : false, message : action.payload, updated : true
        }

      case actionTypes.updated:
        return {
          ...state,
          updated : false
        }
        
      case actionTypes.reset:
        return {
          ...initialState
        }

    default:
      return state;
  }
};
export default submitAnIdeaReducer;
